import type { ComponentPropsWithRef } from "react";
import { BLANK_IMAGE, useAfterPageLoadImage } from "./deferredMedia";
import { siteFileUrl, type SiteFileKey } from "./siteMedia";

type FileImageAttributes = Omit<
  ComponentPropsWithRef<"img">,
  "src" | "srcSet" | "alt" | "loading"
>;

export interface SiteFileImageProps extends FileImageAttributes {
  /** 사이트 미디어의 그림 파일(너비 변형이 없는 SVG 타일·로고) */
  file: SiteFileKey;
  /** 장식이면 빈 문자열 */
  alt: string;
}

/**
 * 첫 화면 밖 그림 파일 — 화면 밖이면 페이지 load 뒤에 주소를 달고, 그 뒤 거리 판단은 브라우저 지연 로드가 한다
 * (site-media-delivery 「첫 화면 우선순위」). 첫 화면 그림은 이 컴포넌트 대신 주소를 바로 단 `<img>` 를 쓴다.
 */
export function SiteFileImage({
  file,
  alt,
  ref,
  ...imgProps
}: SiteFileImageProps) {
  const src = siteFileUrl(file);
  const imageRef = useAfterPageLoadImage(ref, src);
  return (
    // eslint-disable-next-line @next/next/no-img-element -- 사이트 미디어는 파이프라인이 만든 해시 파일을 그대로 쓴다(next/image 최적화 대상 아님)
    <img
      ref={imageRef}
      src={BLANK_IMAGE}
      alt={alt}
      loading="lazy"
      decoding="async"
      {...imgProps}
    />
  );
}
